<div *ngIf="userService.IsCustomUiChange; else oldCustomerInfo">
    <div #customerInfoCard>
        <mat-card class="customer-card" *ngIf="customer.AccountNumber !== undefined">
            <!-- Header Section -->
            <mat-card-header class="customer-header">
                <div class="customer-header-content">
                    <div class="customer-title-section">
                        <mat-icon class="customer-icon">person</mat-icon>
                        <div class="customer-name-wrapper">
                            <h2 class="customer-name">
                                {{ isContractor() ? maskName(customer.Name) : customer.Name | titlecase }}
                            </h2>
                            <button mat-icon-button color="primary" class="edit-btn-inline"
                                matTooltip="Edit Customer Name" *ngIf="!editing && !isContractor()"
                                (click)="startEditingName()">
                                <mat-icon style="color: #3CB371;">edit</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="customer-meta-info">
                        <div class="meta-chip">
                            <span class="meta-label">Provider</span>
                            <span class="meta-value">{{ customer.ProviderName }}</span>
                        </div>
                    </div>
                </div>
            </mat-card-header>

            <!-- Account Details Section -->
            <mat-card-content class="customer-content info-grid">
                <!-- Account Information -->
                <mat-card class="info-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">info</mat-icon>
                        <h3 class="section-title">Account Information</h3>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Account #</span>
                        <span class="info-value">{{ isContractor() ? maskValue(customer.AccountNumber) :
                            customer.AccountNumber }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Start Date</span>
                        <span class="info-value">{{ customer.StartDate | date:'MMM d, yyyy' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">End Date</span>
                        <span class="info-value">{{ customer.LastModifiedDate | date:'MMM d, yyyy' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Rate Code</span>
                        <span class="info-value">{{ customer.RateCode }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">External ID</span>
                        <span class="info-value">{{ customer.ExternalId }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Premise ID</span>
                        <span class="info-value">{{ customer.PremiseId }}</span>
                    </div>
                    <!-- <div class="info-row">
                        <span class="info-label">Account Status</span>
                        <mat-icon [ngClass]="{ expression ? 'status-active' : 'status-inactive' }" class="info-value">circle</mat-icon>
                        {{ response.Status }}
                    </div> -->
                    <div class="action-link">
                        <a class="link-button" (click)="showUsageDialog($event)">
                            <mat-icon>bar_chart</mat-icon>
                            View Usage History
                        </a>
                    </div>
                </mat-card>

                <!-- Addresses Section -->
                <mat-card class="info-section addresses-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">location_on</mat-icon>
                        <h3 class="section-title">Addresses</h3>
                        <mat-icon mat-icon-button color="primary" class="edit-btn-section" matTooltip="Edit Addresses"
                            *ngIf="!editing && !isContractor()" (click)="startEditingAddress()">edit</mat-icon>
                    </div>

                    <div class="address-grid">
                        <div class="address-block">
                            <h4 class="address-title">Service Address</h4>
                            <div class="address-content">
                                <p>{{ isContractor() ? maskValue(customer.ServiceStreetAddress1) :
                                    customer.ServiceStreetAddress1 | titlecase }}</p>
                                <p *ngIf="customer.ServiceBlock">{{ isContractor() ? maskValue(customer.ServiceBlock) :
                                    customer.ServiceBlock | titlecase }}</p>
                                <p *ngIf="customer.ServiceStreetAddress2">{{ isContractor() ?
                                    maskValue(customer.ServiceStreetAddress2) : customer.ServiceStreetAddress2 |
                                    titlecase
                                    }}</p>
                                <p>{{ customer.ServiceCity | titlecase }}, {{ customer.ServiceState | uppercase }} {{
                                    isContractor() ? maskValue(customer.ServiceZipcode) : customer.ServiceZipcode }}</p>
                            </div>
                        </div>

                        <div class="address-block">
                            <h4 class="address-title">Mailing Address</h4>
                            <div class="address-content">
                                <p>{{ isContractor() ? maskValue(customer.MailingStreetAddress1) :
                                    customer.MailingStreetAddress1 | titlecase }}</p>
                                <p *ngIf="customer.MailingBlock">{{ isContractor() ? maskValue(customer.MailingBlock) :
                                    customer.MailingBlock | titlecase }}</p>
                                <p *ngIf="customer.MailingStreetAddress2">{{ isContractor() ?
                                    maskValue(customer.MailingStreetAddress2) : customer.MailingStreetAddress2 |
                                    titlecase
                                    }}</p>
                                <p>{{ customer.MailingCity | titlecase }}, {{ customer.MailingState | uppercase }} {{
                                    isContractor() ? maskValue(customer.MailingZipcode) : customer.MailingZipcode }}</p>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <!-- Contact Information Section -->
                <mat-card class="info-section contact-section" *ngIf="!editing">
                    <div class="section-header">
                        <mat-icon class="section-icon">contact_phone</mat-icon>
                        <h3 class="section-title">Contact Information</h3>
                        <mat-icon mat-icon-button color="primary" class="edit-btn-section"
                            matTooltip="Edit Contact Info" *ngIf="!editing && !isContractor()"
                            (click)="startEditing()">edit</mat-icon>
                    </div>

                    <div class="contact-details">
                        <div class="info-row">
                            <mat-icon class="contact-icon">phone</mat-icon>
                            <div class="contact-info-group">
                                <span class="info-label">Primary Phone</span>
                                <span class="info-value">{{ isContractor() ? maskValue(customer.PrimaryPhone) :
                                    customer.PrimaryPhone }}</span>
                            </div>
                        </div>

                        <div class="info-row" *ngIf="customer.AlternatePhone">
                            <mat-icon class="contact-icon">phone_in_talk</mat-icon>
                            <div class="contact-info-group">
                                <span class="info-label">Alternate Phone</span>
                                <span class="info-value">{{ isContractor() ? maskValue(customer.AlternatePhone) :
                                    customer.AlternatePhone }}</span>
                            </div>
                        </div>

                        <div class="info-row">
                            <mat-icon class="contact-icon">email</mat-icon>
                            <div class="contact-info-group">
                                <span class="info-label">Email</span>
                                <span class="info-value">{{ isContractor() ? maskValue(customer.Email) : customer.Email
                                    }}</span>
                            </div>
                        </div>
                    </div>

                    <mat-divider class="section-divider"></mat-divider>

                    <div class="permissions-section">
                        <h4 class="permissions-title">Contact Preferences</h4>
                        <div class="permissions-grid">
                            <div class="permission-item">
                                <mat-checkbox [(ngModel)]="editCust.DoNotCall" disabled>
                                    <span class="permission-label">Do Not Call</span>
                                </mat-checkbox>
                            </div>
                            <div class="permission-item">
                                <mat-checkbox [(ngModel)]="editCust.DoNotEmail" disabled>
                                    <span class="permission-label">Do Not Email</span>
                                </mat-checkbox>
                            </div>
                            <div class="permission-item">
                                <mat-checkbox [(ngModel)]="editCust.DoNotMail" disabled>
                                    <span class="permission-label">Do Not Mail</span>
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="action-link" *ngIf="extendeinfopseg==1">
                        <a class="link-button" (click)="showAccountInfoDialog($event)">
                            <mat-icon>settings</mat-icon>
                            View/Update Account Info
                        </a>
                    </div>
                </mat-card>

                <!-- Contact Information Edit Mode -->
                <mat-card class="info-section contact-section-edit" *ngIf="editing">
                    <div class="section-header">
                        <mat-icon class="section-icon">contact_phone</mat-icon>
                        <h3 class="section-title">Edit Contact Information</h3>
                    </div>

                    <form class="contact-form">
                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Primary Phone</mat-label>
                                <mat-icon matPrefix>phone</mat-icon>
                                <input matInput placeholder="Enter primary phone" [(ngModel)]="editCust.PrimaryPhone"
                                    name="primaryPhone">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Alternate Phone</mat-label>
                                <mat-icon matPrefix>phone_in_talk</mat-icon>
                                <input matInput placeholder="Enter alternate phone"
                                    [(ngModel)]="editCust.AlternatePhone" name="alternatePhone">
                            </mat-form-field>
                        </div>

                        <mat-form-field appearance="outline" class="form-field full-width">
                            <mat-label>Email</mat-label>
                            <mat-icon matPrefix>email</mat-icon>
                            <input matInput placeholder="Enter email address" [formControl]="emailFC" required>
                            <mat-error *ngIf="emailFC.invalid">Please enter a valid email address</mat-error>
                        </mat-form-field>

                        <mat-divider class="section-divider"></mat-divider>

                        <div class="permissions-section">
                            <h4 class="permissions-title">Contact Preferences</h4>
                            <div class="permissions-grid">
                                <div class="permission-item">
                                    <mat-checkbox color="warn" [(ngModel)]="editCust.DoNotCall" name="doNotCall">
                                        <span class="permission-label">Do Not Call</span>
                                    </mat-checkbox>
                                </div>
                                <div class="permission-item">
                                    <mat-checkbox color="warn" [(ngModel)]="editCust.DoNotEmail" name="doNotEmail">
                                        <span class="permission-label">Do Not Email</span>
                                    </mat-checkbox>
                                </div>
                                <div class="permission-item">
                                    <mat-checkbox color="warn" [(ngModel)]="editCust.DoNotMail" name="doNotMail">
                                        <span class="permission-label">Do Not Mail</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button mat-raised-button color="primary" [disabled]="emailFC.invalid" (click)="doSave()">
                                <mat-icon>save</mat-icon>
                                Save Changes
                            </button>
                            <button mat-stroked-button (click)="cancelEditing()">
                                Cancel
                            </button>
                        </div>
                    </form>
                </mat-card>
            </mat-card-content>
        </mat-card>

        <div class="workorder-interactions-container">
            <div class="left-panel">

                <!-- Enrollments Card (BBCS) -->
                <mat-card class="enrollments-card panel-card" [hidden]="!customerService.isBbcs()">
                    <mat-card-header class="panel-header">
                        <div class="header-content">
                            <mat-icon class="header-icon">school</mat-icon>
                            <h3 class="header-title">Enrollments</h3>
                            <button mat-mini-fab color="primary" class="add-button" [matMenuTriggerFor]="progmenu"
                                matTooltip="Add Enrollment">
                                <mat-icon>add</mat-icon>
                            </button>
                            <mat-menu #progmenu="matMenu">
                                <button mat-menu-item *ngFor="let enaction of enrollmentActions"
                                    (click)="handleEnrollment(enaction)">
                                    <mat-icon>add_circle_outline</mat-icon>
                                    {{ enaction.Value }}
                                </button>
                            </mat-menu>
                        </div>
                    </mat-card-header>

                    <mat-card-content class="panel-content">
                        <mat-spinner *ngIf="loadWorkorder" [diameter]="40" class="centered-spinner"></mat-spinner>

                        <div *ngIf="enrollments.EnrollmentArray.length < 1 && !loadWorkorder" class="empty-state">
                            <mat-icon class="empty-icon">school</mat-icon>
                            <p class="empty-message">No enrollments for the current user</p>
                        </div>

                        <mat-accordion class="enrollment-accordion" *ngIf="enrollments.EnrollmentArray.length > 0">
                            <mat-expansion-panel *ngFor="let wo of displayedEnrollmentRows$ | async"
                                class="enrollment-panel">

                                <mat-expansion-panel-header class="enrollment-header">
                                    <mat-panel-title class="enrollment-title">
                                        <div class="enrollment-info">
                                            <span class="program-name">{{ wo.ProgramDesc }}</span>
                                            <span class="enrollment-meta">
                                                <span class="status-chip">{{ wo.StatusDesc }}</span>
                                                <span class="date-info">
                                                    <mat-icon class="small-icon">event</mat-icon>
                                                    Started {{ wo.StartDate | date:'MMM d, yyyy' }}
                                                </span>
                                            </span>
                                        </div>
                                    </mat-panel-title>

                                    <button mat-icon-button [matMenuTriggerFor]="menu"
                                        (click)="$event.stopPropagation()" matTooltip="Actions">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="addAtWorkorderLevel(wo.EnrollmentId)">
                                            <mat-icon>add</mat-icon>
                                            Add Workorder
                                        </button>
                                    </mat-menu>
                                </mat-expansion-panel-header>

                                <div class="enrollment-content">
                                    <div *ngIf="wo.Workorders === undefined || wo.Workorders.length < 1"
                                        class="empty-state-small">
                                        <mat-icon>assignment_late</mat-icon>
                                        <p>No workorders for this enrollment</p>
                                    </div>

                                    <table *ngIf="wo.Workorders !== undefined && wo.Workorders.length > 0" mat-table
                                        [dataSource]="wo.Workorders" class="enrollment-workorders-table">

                                        <ng-container matColumnDef="Name">
                                            <th mat-header-cell *matHeaderCellDef class="table-header-small">Name</th>
                                            <td mat-cell *matCellDef="let workorder" class="table-cell-small">
                                                {{ workorder.Workorder }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Description">
                                            <th mat-header-cell *matHeaderCellDef class="table-header-small">Description
                                            </th>
                                            <td mat-cell *matCellDef="let workorder" class="table-cell-small">
                                                {{ workorder.ProgramdetailDesc }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="StatusDate">
                                            <th mat-header-cell *matHeaderCellDef class="table-header-small">Status Date
                                            </th>
                                            <td mat-cell *matCellDef="let workorder" class="table-cell-small">
                                                {{ workorder.StatusDate | date:'MMM d, yyyy' }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Status">
                                            <th mat-header-cell *matHeaderCellDef class="table-header-small">Status</th>
                                            <td mat-cell *matCellDef="let workorder" class="table-cell-small">
                                                {{ workorder.StatusDesc }}
                                                <span *ngIf="workorder.Pendhold !== ' '" class="pending-info">({{
                                                    workorder.Pendhold }})</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="ExpandCollapse">
                                            <th mat-header-cell *matHeaderCellDef class="table-header-small"></th>
                                            <td mat-cell *matCellDef="let element" class="table-cell-small">
                                                <mat-icon class="expand-icon">
                                                    {{ element.close ? 'expand_less' : 'expand_more' }}
                                                </mat-icon>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns5"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns5;"
                                            (dblclick)="handleEnrollmentWorkorderClick(row, wo.EnrollmentId)"
                                            [cdkDetailRow]="row" [cdkDetailRowTpl]="tpl"
                                            (toggleChange)="onToggleChange($event, row)"
                                            class="clickable-row enrollment-row">
                                        </tr>
                                    </table>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>

                    </mat-card-content>
                    <mat-paginator #EnrollPaginator [length]="totalEnrollmentRows$ | async" [pageIndex]="0"
                        [pageSize]="50" [pageSizeOptions]="[50, 100]" class="custom-paginator">
                    </mat-paginator>
                </mat-card>

                <!-- Workorders Card (Non-BBCS) -->
                <mat-card class="workorders-card panel-card" [hidden]="customerService.isBbcs()">
                    <mat-card-header class="workorder-panel-header">
                        <div class="header-content">
                            <mat-icon class="header-icon">assignment</mat-icon>
                            <h3 class="header-title">Work Orders</h3>
                        </div>
                    </mat-card-header>

                    <mat-card-content class="panel-content">
                        <mat-spinner *ngIf="loadWorkorder" [diameter]="40" class="centered-spinner"></mat-spinner>

                        <div *ngIf="!workorderDisplay && !loadWorkorder" class="empty-state">
                            <mat-icon class="empty-icon">assignment_late</mat-icon>
                            <p class="empty-message">No workorders for the current user</p>
                        </div>

                        <div *ngIf="workorderDisplay && !loadWorkorder" class="data-table-wrapper">
                            <table mat-table [dataSource]="dataSource2" class="custom-table">

                                <ng-container matColumnDef="Name">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Name</th>
                                    <td mat-cell *matCellDef="let workorder" class="table-cell">
                                        <div class="cell-content">
                                            <mat-icon class="cell-icon">description</mat-icon>
                                            <span>{{ workorder.Name }}</span>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="StatusDate">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Status Date</th>
                                    <td mat-cell *matCellDef="let workorder" class="table-cell">
                                        {{ workorder.StatusDate | date:'MMM d, yyyy' }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Status">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Status</th>
                                    <td mat-cell *matCellDef="let workorder" class="table-cell">
                                        <span class="status-badge"
                                            [ngClass]="'status-' + workorder.Status.toLowerCase()">
                                            {{ workorder.Status }}
                                        </span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns3;"
                                    (click)="handleWorkorderClick(row)" class="clickable-row"></tr>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-card>

                <!-- Interactions Card -->
                <mat-card class="interactions-card panel-card" *ngIf="!isRestrictedUser()">
                    <mat-card-header class="panel-header">
                        <div class="header-content">
                            <mat-icon class="header-icon">forum</mat-icon>
                            <h3 class="header-title">Interactions</h3>
                            <button mat-mini-fab color="primary" class="add-button" matTooltip="Add Interaction"
                                (click)="addNewInteraction()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-card-header>

                    <mat-card-content class="panel-content">
                        <mat-spinner *ngIf="loadInteraction" [diameter]="40" class="centered-spinner"></mat-spinner>

                        <div *ngIf="!interactionDisplay && !loadInteraction" class="empty-state">
                            <mat-icon class="empty-icon">chat_bubble_outline</mat-icon>
                            <p class="empty-message">{{ interactionMessage }}</p>
                        </div>

                        <div *ngIf="interactionDisplay && !loadInteraction" class="data-table-wrapper">
                            <table mat-table [dataSource]="dataSource1" class="custom-table">

                                <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Type</th>
                                    <td mat-cell *matCellDef="let interaction" class="table-cell">
                                        <div class="cell-content">
                                            <mat-icon class="cell-icon">label</mat-icon>
                                            <span>{{ interaction.TypeDescription | titlecase }}</span>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Why</th>
                                    <td mat-cell *matCellDef="let interaction" class="table-cell">
                                        {{ interaction.WhyDescription | titlecase }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef class="table-header">Start Date</th>
                                    <td mat-cell *matCellDef="let interaction" class="table-cell">
                                        <div class="date-cell">
                                            <mat-icon class="date-icon">schedule</mat-icon>
                                            {{ (interaction.StartDate || interaction.CreatedDate) | date:'MMM d, yyyy
                                            h:mm
                                            a' }}
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns1;"
                                    (click)="handleInteractionClick(row)" class="clickable-row"></tr>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-card>

            </div>

            <mat-card class="details-card">
                <mat-card-content class="details-content" #detailsCard>
                    <mat-tab-group #detailTabs class="custom-tabs"
                        [class]="workorderService.getCustomTabCSSForOfficeId()">

                        <!-- Detail Tab -->
                        <mat-tab label="Details">
                            <div class="tab-content">

                                <!-- Loading States -->
                                <mat-spinner *ngIf="showWorkorderLoad || showInteractionLoad" [diameter]="60"
                                    class="centered-spinner"></mat-spinner>

                                <!-- Empty State -->
                                <div *ngIf="!showWorkorder && !showInteraction && !showWorkorderLoad && !showInteractionLoad"
                                    class="empty-state-large">
                                    <mat-icon class="empty-icon-large">info</mat-icon>
                                    <h3>Select an Item</h3>
                                    <p>Choose a workorder or interaction to view details</p>
                                </div>

                                <!-- Interaction Details -->
                                <div *ngIf="showInteraction && !showInteractionLoad" class="detail-section">
                                    <div class="detail-header">
                                        <mat-icon class="detail-icon">forum</mat-icon>
                                        <h3>Interaction Details</h3>
                                    </div>

                                    <div class="info-cards-grid">
                                        <mat-card class="info-mini-card">
                                            <div class="mini-card-content">
                                                <span class="mini-label">User</span>
                                                <span class="mini-value">{{ selectedInteraction.User }}</span>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-mini-card">
                                            <div class="mini-card-content">
                                                <span class="mini-label">Start Date</span>
                                                <span class="mini-value">{{ selectedInteraction.StartDate | date:'MMM d,
                                                    yyyy
                                                    h:mm a' }}</span>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-mini-card">
                                            <div class="mini-card-content">
                                                <span class="mini-label">End Date</span>
                                                <span class="mini-value">{{ selectedInteraction.EndDate | date:'MMM d,
                                                    yyyy
                                                    h:mm
                                                    a' }}</span>
                                            </div>
                                        </mat-card>
                                    </div>

                                    <div class="info-cards-grid">
                                        <mat-card class="info-card">
                                            <h4 class="card-subtitle">Type & Reason</h4>
                                            <div class="card-info-row">
                                                <span class="info-label">Type:</span>
                                                <span class="info-value">{{ selectedInteraction.TypeDescription |
                                                    titlecase
                                                    }}</span>
                                            </div>
                                            <div class="card-info-row">
                                                <span class="info-label">Why:</span>
                                                <span class="info-value">{{ selectedInteraction.WhyDescription |
                                                    titlecase
                                                    }}</span>
                                            </div>
                                            <div class="card-info-row">
                                                <span class="info-label">Marketing:</span>
                                                <span class="info-value">{{ selectedInteraction.MarketingDescription
                                                    }}</span>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-card">
                                            <h4 class="card-subtitle">Status</h4>
                                            <div class="card-info-row">
                                                <span class="info-label">Complete:</span>
                                                <mat-icon *ngIf="interactionIsComplete"
                                                    class="check-icon">check_circle</mat-icon>
                                                <mat-icon *ngIf="!interactionIsComplete"
                                                    class="cross-icon">cancel</mat-icon>
                                            </div>
                                            <div class="card-info-row">
                                                <span class="info-label">Reason Not Done:</span>
                                                <span class="info-value">{{ selectedInteraction.ReasonDescription ||
                                                    'N/A'
                                                    }}</span>
                                            </div>
                                        </mat-card>
                                    </div>

                                    <mat-card class="notes-card">
                                        <h4 class="card-subtitle">
                                            <mat-icon class="subtitle-icon">notes</mat-icon>
                                            Notes
                                        </h4>
                                        <p class="notes-content">{{ selectedInteraction.Notes || 'No notes available' }}
                                        </p>
                                    </mat-card>
                                </div>

                                <!-- Workorder Details -->
                                <div *ngIf="showWorkorder && !showWorkorderLoad" class="detail-section">
                                    <div class="detail-header-wo">
                                        <div class="wo-title-section">
                                            <mat-icon class="detail-icon">assignment</mat-icon>
                                            <h3 class="wo-program-name">{{ selectedWorkorder.ProgramName }}</h3>
                                        </div>
                                        <a class="wo-link"
                                            (click)="showWorkorderHistory(selectedWorkorder.WorkorderId)">
                                            <mat-icon>history</mat-icon>
                                            Workorder: {{ selectedWorkorder.WorkorderName }}
                                        </a>
                                    </div>

                                    <div class="info-cards-grid-three">
                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">person</mat-icon>
                                                <h4 class="card-title-small">Customer Details</h4>
                                            </div>
                                            <div class="card-body">
                                                <p class="detail-line">{{ selectedWorkorder.CustomerName | titlecase }}
                                                </p>
                                                <p class="detail-line">{{ selectedWorkorder.CustomerStreet | titlecase
                                                    }}
                                                </p>
                                                <p class="detail-line">
                                                    {{ selectedWorkorder.CustomerCity | titlecase }},
                                                    {{ selectedWorkorder.CustomerState | uppercase }}
                                                    {{ selectedWorkorder.CustomerZip }}
                                                </p>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">payment</mat-icon>
                                                <h4 class="card-title-small">Payee Details</h4>
                                            </div>
                                            <div class="card-body">
                                                <p class="detail-line">{{ selectedWorkorder.PayeeName | titlecase }}</p>
                                                <p class="detail-line">{{ selectedWorkorder.PayeeEmail }}</p>
                                                <p class="detail-line">{{ selectedWorkorder.PayeeAddress | titlecase }}
                                                </p>
                                                <p class="detail-line">
                                                    {{ selectedWorkorder.PayeeCity | titlecase }},
                                                    {{ selectedWorkorder.PayeeState | uppercase }}
                                                    {{ selectedWorkorder.PayeeZip }}
                                                </p>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">business</mat-icon>
                                                <h4 class="card-title-small">Contractor Details</h4>
                                            </div>
                                            <div class="card-body">
                                                <div class="detail-row">
                                                    <span class="row-label">Service Provider:</span>
                                                    <span class="row-value">{{ selectedWorkorder.ServiceProviderName
                                                        }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Phone:</span>
                                                    <span class="row-value">{{ selectedWorkorder.ContractorPhone
                                                        }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Email:</span>
                                                    <span class="row-value">{{ selectedWorkorder.ContractorEmail
                                                        }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Contact:</span>
                                                    <span class="row-value">{{ selectedWorkorder.CompanyContact
                                                        }}</span>
                                                </div>
                                            </div>
                                        </mat-card>
                                    </div>

                                    <div class="info-cards-grid">
                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">account_balance_wallet</mat-icon>
                                                <h4 class="card-title-small">Rebate Details</h4>
                                            </div>
                                            <div class="card-body">
                                                <div class="detail-row">
                                                    <span class="row-label">Amount Paid:</span>
                                                    <span class="row-value highlight">{{ selectedWorkorder.AmountPaid
                                                        }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Check #:</span>
                                                    <span class="row-value">{{ selectedWorkorder.CheckNumber }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Date Paid:</span>
                                                    <span class="row-value">{{ selectedWorkorder.DatePaid | date:'MMM d,
                                                        yyyy'
                                                        }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Delivery Method:</span>
                                                    <span class="row-value">{{ selectedWorkorder.MailorEmail }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Payment Status:</span>
                                                    <span class="row-value">{{ selectedWorkorder.PaymentStatus }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <span class="row-label">Status Date:</span>
                                                    <span class="row-value">{{ selectedWorkorder.WorkorderStatusDate |
                                                        date:'MMM
                                                        d, yyyy' }}</span>
                                                </div>
                                                <div class="detail-row"
                                                    *ngIf="selectedWorkorder.WorkorderApplicationSource">
                                                    <span class="row-label">Application Source:</span>
                                                    <span class="row-value">{{
                                                        selectedWorkorder.WorkorderApplicationSource
                                                        }}</span>
                                                </div>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">attachment</mat-icon>
                                                <h4 class="card-title-small">Attachments</h4>
                                            </div>
                                            <div class="card-body">
                                                <div *ngIf="showAttachMessage" class="empty-state-small">
                                                    <p>{{ attachmentMessage }}</p>
                                                </div>

                                                <table *ngIf="!showAttachMessage" mat-table [dataSource]="dataSource3"
                                                    class="attachments-table">
                                                    <ng-container matColumnDef="name">
                                                        <th mat-header-cell *matHeaderCellDef>Name</th>
                                                        <td mat-cell *matCellDef="let attachment">
                                                            <div class="attachment-cell">
                                                                <mat-icon class="file-icon">insert_drive_file</mat-icon>
                                                                {{ attachment.FileName }}
                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="date">
                                                        <th mat-header-cell *matHeaderCellDef>Date</th>
                                                        <td mat-cell *matCellDef="let attachment">
                                                            {{ attachment.DateUploaded | date:'MMM d, yyyy' }}
                                                        </td>
                                                    </ng-container>

                                                    <tr mat-header-row *matHeaderRowDef="displayedColumns4"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumns4;"
                                                        (click)="handleAttachmentClick(row)" class="clickable-row"></tr>
                                                </table>

                                                <mat-paginator #attachpaginator [pageSize]="3" showFirstLastButtons
                                                    class="mini-paginator">
                                                </mat-paginator>
                                            </div>
                                        </mat-card>
                                    </div>

                                    <div class="info-cards-grid">
                                        <mat-card class="info-card-detail">
                                            <div class="card-header-small">
                                                <mat-icon class="card-icon">description</mat-icon>
                                                <h4 class="card-title-small">Workorder Notes</h4>
                                            </div>
                                            <div class="card-body">
                                                <p class="notes-text">
                                                    {{ selectedWorkorder.InstalledWONotes || 'No Workorder Notes' }}
                                                </p>
                                            </div>
                                        </mat-card>

                                        <mat-card class="info-card-detail warning-card"
                                            *ngIf="selectedWorkorder.WorkorderExceptions">
                                            <div class="card-header-small warning-header">
                                                <mat-icon class="card-icon">warning</mat-icon>
                                                <h4 class="card-title-small">Workorder Exceptions</h4>
                                            </div>
                                            <div class="card-body">
                                                <p class="warning-text">{{ selectedWorkorder.WorkorderExceptions }}</p>
                                            </div>
                                        </mat-card>
                                    </div>

                                    <mat-card class="info-card-detail error-card"
                                        *ngIf="['Deactivated', 'Canceled'].includes(selectedWorkorder.WorkorderStatus)">
                                        <div class="card-header-small error-header">
                                            <mat-icon class="card-icon">block</mat-icon>
                                            <h4 class="card-title-small">Deactivate/Cancel Reason</h4>
                                        </div>
                                        <div class="card-body">
                                            <p class="error-text">{{ selectedWorkorder.DeactivationReasons || 'No reason
                                                provided' }}</p>
                                        </div>
                                    </mat-card>
                                </div>
                            </div>
                        </mat-tab>

                        <!-- Measures Tab -->
                        <mat-tab label="Measures" [disabled]="!showWorkorder">
                            <div class="tab-content">
                                <div *ngIf="!measuresSearching && measures.MeasuresArray.length === 0"
                                    class="empty-state-large">
                                    <mat-icon class="empty-icon-large">dashboard</mat-icon>
                                    <h3>No Measures</h3>
                                    <p>No measures available for the selected workorder</p>
                                </div>

                                <div *ngIf="measures.MeasuresArray.length > 0" class="measures-section">
                                    <div class="measures-header">
                                        <button mat-stroked-button (click)="closeAll()" class="collapse-btn">
                                            <mat-icon>unfold_less</mat-icon>
                                            Collapse All
                                        </button>
                                        <mat-paginator #MeasurePaginator [length]="totalRows$ | async" [pageIndex]="0"
                                            [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
                                            class="custom-paginator">
                                        </mat-paginator>
                                    </div>

                                    <mat-accordion #accordion="matAccordion" multi class="measures-accordion">
                                        <mat-expansion-panel *ngFor="let measure of displayedRows$ | async"
                                            class="measure-panel">
                                            <mat-expansion-panel-header class="measure-header">
                                                <mat-panel-title class="measure-title">
                                                    <div class="measure-grid">
                                                        <span class="measure-name">{{ measure.Name }}</span>
                                                        <span class="measure-category">{{ measure.Category }}</span>
                                                        <span class="measure-quantity">Qty: {{ measure.Quantity
                                                            }}</span>
                                                        <span class="measure-status">
                                                            <span class="status-badge"
                                                                [ngClass]="'status-' + measure.Status.toLowerCase()">
                                                                {{ measure.Status }}
                                                            </span>
                                                        </span>
                                                        <span class="measure-cost">{{ measure.Cost | currency }}</span>
                                                    </div>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>

                                            <div class="measure-content">
                                                <p *ngIf="measure.Notes" class="measure-notes">
                                                    <mat-icon class="notes-icon">notes</mat-icon>
                                                    <strong>Notes:</strong> {{ measure.Notes }}
                                                </p>

                                                <div *ngIf="measure.MeasureAttributes.length === 0"
                                                    class="empty-state-small">
                                                    <mat-icon>warning</mat-icon>
                                                    <p>No attributes for this measure</p>
                                                </div>

                                                <table *ngIf="measure.MeasureAttributes.length > 0"
                                                    class="attributes-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Attribute Name</th>
                                                            <th>Attribute Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let attr of measure.MeasureAttributes"
                                                            class="attribute-row">
                                                            <td>{{ attr.Name }}</td>
                                                            <td>{{ attr.Value }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            </div>
                        </mat-tab>

                        <!-- Exceptions Tab -->
                        <mat-tab label="Exceptions" [disabled]="!showWorkorder">
                            <div class="tab-content">
                                <div class="empty-state-large">
                                    <mat-icon class="empty-icon-large">error_outline</mat-icon>
                                    <h3>No Exceptions</h3>
                                    <p>No exceptions found for the selected workorder</p>
                                </div>
                            </div>
                        </mat-tab>

                        <!-- Add Interactions Tab -->
                        <mat-tab label="Add Interaction" *ngIf="showAddInteractions">
                            <div class="tab-content add-interaction-form">
                                <div class="timer-display">
                                    <mat-icon>timer</mat-icon>
                                    <span>{{ timer }}</span>
                                </div>

                                <form class="interaction-form">
                                    <div class="form-fields">
                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Type</mat-label>
                                            <mat-icon matPrefix>category</mat-icon>
                                            <mat-select [(ngModel)]="selectedTypeCode"
                                                (selectionChange)="changeType($event)" name="type">
                                                <mat-option *ngFor="let typeobj of types" [value]="typeobj">
                                                    {{ typeobj.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Why</mat-label>
                                            <mat-icon matPrefix>help_outline</mat-icon>
                                            <mat-select [(ngModel)]="selectedWhy" name="why">
                                                <mat-option *ngFor="let why of whys" [value]="why">
                                                    {{ why.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="form-field">
                                            <mat-label>Marketing</mat-label>
                                            <mat-icon matPrefix>campaign</mat-icon>
                                            <mat-select [(ngModel)]="selectedMarketing" name="marketing">
                                                <mat-option *ngFor="let marketObj of marketing" [value]="marketObj">
                                                    {{ marketObj.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <mat-form-field appearance="outline" class="form-field full-width">
                                        <mat-label>Notes</mat-label>
                                        <mat-icon matPrefix>notes</mat-icon>
                                        <textarea matInput rows="4" placeholder="Enter interaction notes..."
                                            [(ngModel)]="notesInput" name="notes"></textarea>
                                    </mat-form-field>

                                    <div class="completion-section">
                                        <mat-checkbox #completeCheckbox color="warn" (change)="onCompleteClick($event)"
                                            name="complete">
                                            Mark as Complete
                                        </mat-checkbox>

                                        <mat-form-field appearance="outline" class="form-field reason-field">
                                            <mat-label>Reason Not Completed</mat-label>
                                            <mat-icon matPrefix>info</mat-icon>
                                            <mat-select [disabled]="checkIfComplete" [(ngModel)]="selectedReason"
                                                name="reason">
                                                <mat-option *ngFor="let reason of reasons" [value]="reason">
                                                    {{ reason.value }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-actions">
                                        <button mat-raised-button color="primary" (click)="addInteraction()"
                                            [disabled]="checkGoodDropForm() || adding">
                                            <mat-icon>save</mat-icon>
                                            Save Interaction
                                        </button>
                                        <button mat-stroked-button (click)="closeInteractions()">
                                            Cancel
                                        </button>
                                    </div>

                                    <div *ngIf="statusMessage" class="status-message">
                                        {{ statusMessage }}
                                    </div>
                                </form>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </mat-card-content>
            </mat-card>

        </div>
        <button mat-fab class="scroll-to-top" (click)="scrollToBuckets(customerInfoCard)">
            <mat-icon>arrow_upward</mat-icon>
        </button>
    </div>
    <!-- Assignment Details Template -->
    <ng-template #tpl let-element>
        <tr class="assignment-detail-row">
            <td [attr.colspan]="displayedColumns5.length">
                <div [@detailExpand] class="assignment-details">
                    <div *ngFor="let assign of element.Assignments" class="assignment-item">
                        <mat-card class="assignment-card">
                            <div class="assignment-content">
                                <div class="assignment-field">
                                    <span class="field-label">Status</span>
                                    <span class="field-value">{{ assign.Status }}</span>
                                </div>
                                <div class="assignment-field">
                                    <span class="field-label">Assignee</span>
                                    <span class="field-value">{{ assign.Assignee }}</span>
                                </div>
                                <div class="assignment-field">
                                    <span class="field-label">Start Date</span>
                                    <span class="field-value">{{ assign.Start }}</span>
                                </div>
                            </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</div>

<ng-template #oldCustomerInfo>
    <mat-accordion *ngIf="customer.AccountNumber !== undefined">
        <mat-expansion-panel [expanded]="true"
            style=" margin-top:1vw !important; margin-bottom: 0;margin-right: 1.5vw;">
            <mat-expansion-panel-header style="font-size: 13px;padding: 0 24px 10px;">
                <table class="mat-elevation-z8" style="height: 3vw !important; font-size: 0.9vw ">
                    <tr [class]="workorderService.getCustomCSSForOfficeId(false)" style="color:whitesmoke">
                        <th>Customer Name</th>
                        <th style="text-align: center;width:5.5vw">Account No</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Rate Code</th>
                        <th>External Id</th>
                        <th>Provider</th>
                    </tr>

                    <tr>
                        <td style="text-align: center;">{{ isContractor() ? maskName(customer.Name) : customer.Name |
                            titlecase }}
                            <button mat-icon-button color="accent" class="editicon-cs" matTooltip="Edit Customer Name"
                                style="height: 32px; width: 48px;padding-bottom: 0.5em;"
                                *ngIf="!editing && !isContractor()" (click)=startEditingName()>
                                <mat-icon class="myIcon">edit</mat-icon>
                            </button>
                        </td>
                        <td style="text-align: center; width:1.5vw"> {{ isContractor() ?
                            maskValue(customer.AccountNumber) : customer.AccountNumber }} </td>
                        <td style="text-align: center"> {{customer.StartDate | date:'M/d/yyyy'}}</td>
                        <td style="text-align: center"> {{customer.LastModifiedDate | date:'M/d/yyyy'}} </td>
                        <td style="text-align: center"> {{customer.RateCode}} </td>
                        <td style="text-align: center"> {{customer.ExternalId}} </td>
                        <td style="text-align: center"> {{customer.ProviderName}} </td>
                        <table class="view-usage">
                            <tr>
                                <td>
                                    <a class="custom-link" (click)="showUsageDialog($event)">View Usage</a>
                                </td>
                            </tr>
                        </table>
                    </tr>
                </table>
            </mat-expansion-panel-header>

            <div class="table-detail">
                <table class="mat-elevation-z8 addressTable" style="font-size: 0.9vw !important">
                    <tr [class]="workorderService.getCustomCSSForOfficeId(false)" style="color:whitesmoke;">
                        <th class="tableHeader">Mailing Address</th>
                        <th class="tableHeader">Service Address</th>
                        <button mat-icon-button color="accent" class="editicon-cs" matTooltip="Edit" style="height: 37px;
                    width: 48px;" *ngIf="!editing && !isContractor()" (click)=startEditingAddress()>
                            <mat-icon class="myIcon">edit</mat-icon>
                        </button>
                    </tr>

                    <tr class="rowStyle">
                        <td> {{ isContractor() ? maskValue(customer.MailingStreetAddress1) :
                            customer.MailingStreetAddress1 | titlecase}} </td>
                        <td> {{ isContractor() ? maskValue(customer.ServiceStreetAddress1) :
                            customer.ServiceStreetAddress1 | titlecase}}</td>
                    </tr>
                    <tr class="rowStyle">
                        <td> {{ isContractor() ? maskValue(customer.MailingBlock) : customer.MailingBlock | titlecase}}
                        </td>
                        <td> {{ isContractor() ? maskValue(customer.ServiceBlock) : customer.ServiceBlock| titlecase}}
                        </td>
                    </tr>
                    <tr class="rowStyle">
                        <td> {{ isContractor() ? maskValue(customer.MailingStreetAddress2) :
                            customer.MailingStreetAddress2 | titlecase}} </td>
                        <td> {{ isContractor() ? maskValue(customer.ServiceStreetAddress2) :
                            customer.ServiceStreetAddress2 | titlecase}}</td>
                    </tr>
                    <tr class="rowStyle">
                        <td> {{ customer.MailingCity | titlecase}}, {{ customer.MailingState | uppercase}}
                            {{ isContractor() ? maskValue(customer.MailingZipcode) : customer.MailingZipcode}}</td>
                        <td> {{ customer.ServiceCity | titlecase}}, {{ customer.ServiceState | uppercase}}
                            {{ isContractor() ? maskValue(customer.ServiceZipcode) : customer.ServiceZipcode }} </td>
                    </tr>
                </table>

                <!-- Display only -->
                <table class="mat-elevation-z8 addressTable-csut" *ngIf="!editing" style="font-size: 0.9vw !important">
                    <tr [class]="workorderService.getCustomCSSForOfficeId(false)" style="color:whitesmoke;">
                        <th class="tableHeade1" style="width: 20%;">
                            Contact Permissions
                        </th>
                        <th class="tableHeader flex-th">
                            <span style="padding-right: 47%; margin-right: 105%;margin-left: 13%;">Contacts</span>
                            <button mat-icon-button color="accent" class="editicon-cs" matTooltip="Edit" style="height: 37px;
                        width: 48px;" *ngIf="!editing && !isContractor()" (click)=startEditing()>
                                <mat-icon class="myIcon">edit</mat-icon>
                            </button>
                        </th>
                    </tr>
                    <tr class="rowStyle">
                        <td class="donotmarkup row-single">
                            <div>
                                <!-- <span class="donottext">Do Not Call</span> -->
                                <!-- <mat-icon *ngIf="customer.DoNotCall" style="font-size:1.2vw !important">check</mat-icon> -->
                                <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotCall" disabled>Do Not
                                    Call</mat-checkbox>
                            </div>
                            <div>
                                <!-- <span class="donottext">Do Not Email</span> -->
                                <!-- <mat-icon *ngIf="customer.DoNotEmail" style="font-size:1.2vw !important">check</mat-icon> -->
                                <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotEmail" disabled>Do Not
                                    Email</mat-checkbox>
                            </div>
                        </td>
                        <td style="text-align: initial;">
                            <p class="remove-mar"><span class="text-info">Primary Phone: </span>{{ isContractor() ?
                                maskValue(customer.PrimaryPhone) : customer.PrimaryPhone }}&nbsp;&nbsp;&nbsp;<span
                                    class="text-info">Alternate Phone: </span>{{ isContractor() ?
                                maskValue(customer.AlternatePhone) : customer.AlternatePhone }}</p>
                        </td>

                    </tr>
                    <tr class="rowStyle">
                        <td class="donotmarkup" style="text-align: initial;">
                            <!-- <span class="donottext">Do Not Mail</span> -->
                            <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotMail" disabled>Do Not
                                Mail</mat-checkbox>
                            <!-- <mat-icon *ngIf="customer.DoNotMail" style="font-size:1.2vw !important">check</mat-icon> -->
                        </td>
                        <td style="text-align: initial;">
                            <span class="text-info">Email: </span>{{ isContractor() ? maskValue(customer.Email) :
                            customer.Email }}
                        </td>
                        <div *ngIf="extendeinfopseg==1">
                            <table class="view-account">
                                <tr>
                                    <td colspan="2">
                                        <a class="custom-link" (click)="showAccountInfoDialog($event)">View/Update
                                            Account Info</a>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </tr>
                    <!-- <tr>
                    <td colspan="2" style="text-align: center">
                        <button mat-raised-button color="primary" *ngIf="!editing" (click)="startEditing()">EDIT</button>

                        <button mat-icon-button color="accent"  *ngIf="!editing" (click)=startEditing()>
                            <mat-icon>edit</mat-icon>
                        </button>
                    </td>
                </tr> -->
                </table>

                <!-- Editing table -->
                <table class="mat-elevation-z8 addressTable-csut" *ngIf="editing" style="font-size: 0.9vw !important">
                    <tr [class]="workorderService.getCustomCSSForOfficeId(false)" style="color:whitesmoke;">
                        <th class="tableHeader1" style="width: 20%;">
                            Contact Permissions
                        </th>
                        <th class="tableHeader" style="width: 67%;">
                            Contacts
                        </th>
                        <th style="background: white;"></th>
                    </tr>
                    <tr class="rowStyle">
                        <td class="row-single">
                            <div>
                                <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotCall">Do Not
                                    Call</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotEmail">Do Not
                                    Email</mat-checkbox>
                            </div>
                        </td>
                        <td>
                            <div class="row-single">
                                <mat-form-field style="width:80% !important">
                                    <input matInput placeholder="Primary Phone" [(ngModel)]="editCust.PrimaryPhone">
                                </mat-form-field>
                                <mat-form-field style="width:80% !important">
                                    <input matInput placeholder="Alternate Phone" [(ngModel)]="editCust.AlternatePhone">
                                </mat-form-field>
                            </div>
                        </td>
                    </tr>
                    <tr class="rowStyle">
                        <td style="text-align: initial;">
                            <mat-checkbox class="cb-margin" [(ngModel)]="editCust.DoNotMail">Do Not Mail</mat-checkbox>
                        </td>
                        <td style="text-align: initial;">
                            <mat-form-field style="width:80% !important">
                                <input matInput placeholder="Email" [formControl]="emailFC" required>
                                <mat-error *ngIf="emailFC.invalid">Not a valid email</mat-error>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr class="rowStyle">
                        <td colspan="2" style="text-align: center">
                            <button mat-raised-button color="primary" [disabled]='emailFC.invalid' *ngIf="editing"
                                (click)="doSave()">SAVE</button>
                            <button style="margin-left:0.5vw" mat-raised-button color="primary" *ngIf="editing"
                                (click)="cancelEditing()">CANCEL</button>
                        </td>

                    </tr>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <!-- For the interactions/workorder and details display -->
    <div style="margin-top:1.5vw !important">
        <mat-card style="float: left; width: 35%; min-height: 17vw !important;overflow: auto;">
            <mat-card-header [class]="workorderService.getCustomCSSForOfficeId(false)"
                style="align-items: center; font-size:0.9vw;color:whitesmoke ;">
                Interactions
                <button matTooltip="Add" mat-button (click)="addNewInteraction()"
                    style="background: transparent;margin-left:18vw !important">
                    <mat-icon>
                        add
                    </mat-icon>
                </button>
            </mat-card-header>

            <mat-card-content style="height: 2vw !important;">
                <mat-spinner *ngIf="loadInteraction" [diameter]="40"
                    style="margin:0 auto; text-align:center; margin-top:2vw"></mat-spinner>
                <table *ngIf="interactionDisplay && !loadInteraction"
                    style="width: 100% !important; margin-top: 1.2vw !important" mat-table [dataSource]="dataSource1"
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="type">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)" *matHeaderCellDef
                            style="text-align: left; font-size: 0.8vw">Type</th>
                        <td style="font-size:0.8vw; text-align: left" mat-cell *matCellDef="let interaction">
                            {{interaction.TypeDescription | titlecase}} </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)" *matHeaderCellDef
                            style="text-align: left;font-size: 0.8vw">Why</th>
                        <td style="font-size:0.8vw; text-align: left" mat-cell *matCellDef="let interaction">
                            {{interaction.WhyDescription | titlecase}} </td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                            style="text-align: left;font-size: 0.8vw" *matHeaderCellDef>Start Date</th>
                        <td mat-cell style="font-size:0.8vw;text-align: left" *matCellDef="let interaction">
                            {{(interaction.StartDate == null ? interaction.CreatedDate : interaction.StartDate)|
                            date:'M/d/yyyy h:mm:ss a'}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;" (click)="handleInteractionClick(row)"
                        class="curr-interaction"></tr>
                </table>
                <div *ngIf="!interactionDisplay  && !loadInteraction" style="
            vertical-align: middle;
            text-align: center;
            margin: 0 auto;
            margin-top: 10vw;">{{interactionMessage}}</div>

            </mat-card-content>
            <!-- <mat-paginator #paginator [pageSize]="5" showFirstLastButtons></mat-paginator> -->
        </mat-card>
        <mat-card style="float: right; width: 55%; height: 70vh !important; margin-bottom: 1vw; margin-right: 1.5vw;">
            <!--   <mat-card-header style="align-items: center;font-size:0.9vw;color:whitesmoke ;background: #2196F3;
        height: 2.5%;padding-top:1vw;padding-bottom:1vw">
            Details <mat-spinner *ngIf="showWorkorder && loadAttachments" [diameter]="30" style="color: white"
                style="margin:0 auto; text-align:center;margin-top:0.5vw"></mat-spinner>
        </mat-card-header> -->
            <mat-card-content style="height: 100% !important">
                <mat-tab-group #detailTabs [class]="workorderService.getCustomTabCSSForOfficeId()"
                    style="width: 99% !important;height: 100% !important;">
                    <mat-tab label="Detail">

                        <mat-spinner *ngIf="showWorkorderLoad && !showInteractionLoad" [diameter]="70" color="primary"
                            style="margin: 0 auto; width:50%; height: 100%; margin-top: 0.5vw">
                        </mat-spinner>

                        <mat-spinner *ngIf="showInteractionLoad && !showWorkorderLoad" [diameter]="70" color="primary"
                            style="margin: 0 auto; width:50%; height: 100%;margin-top: 0.5vw">
                        </mat-spinner>


                        <label *ngIf="!showWorkorder && !showInteraction" style="float: left;         
                            width: 100%;
                            text-align: center;
                            font-size: 1vw;margin-top:1vw">Select Workorder / Interaction</label>

                        <table *ngIf="showInteraction" class="mat-elevation-z8"
                            style="width:90% !important; margin-top: 3vw;font-size: 0.9vw; margin-left:3vw">
                            <tr style="background-color:#CFD8DC;color:black;height: 2vw;">
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">User</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Start Date</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">End Date</th>
                            </tr>
                            <tr class="rowStyle" style="height: 2vw !important">
                                <td>{{selectedInteraction.User}}</td>
                                <td>{{selectedInteraction.StartDate | date :'M/dd/yy h:mm:ss a'}}</td>
                                <td>{{selectedInteraction.EndDate | date :'M/dd/yy h:mm:ss a'}}</td>
                            </tr>
                        </table>

                        <table *ngIf="showInteraction" class="mat-elevation-z8"
                            style="width:90% !important;margin-left:3vw !important; margin-top: 3vw;font-size: 0.9vw">
                            <tr style="background-color:#CFD8DC;color:black;height: 2vw;">
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Type</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Why</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Complete</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Reason Not Done</th>
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Marketing</th>
                            </tr>
                            <tr class="rowStyle" style="height: 2vw !important">
                                <td>{{selectedInteraction.TypeDescription | titlecase}}</td>
                                <td>{{selectedInteraction.WhyDescription | titlecase}}</td>
                                <td matTooltip="Check">
                                    <mat-icon *ngIf="interactionIsComplete">check</mat-icon>
                                </td>
                                <td>{{selectedInteraction.ReasonDescription}}</td>
                                <td>{{selectedInteraction.MarketingDescription}}</td>
                            </tr>

                        </table>
                        <table *ngIf="showInteraction" class="mat-elevation-z8"
                            style="width:94% !important;margin-bottom: 2vw; margin-left:2vw; margin-top: 3vw;font-size: 0.9vw">
                            <tr style="background-color:#CFD8DC;color:black;height: 2vw;">
                                <th [class]="workorderService.getCustomCSSForOfficeId(false)">Notes</th>
                            </tr>
                            <tr class="rowStyle" style="height: 2.5vw !important; overflow-wrap: anywhere;">
                                <td>
                                    <div>{{selectedInteraction.Notes}}</div>
                                </td>
                            </tr>
                        </table>

                        <span *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="margin-left:1vw; float:left;font-size: 1.2vw;margin-top:0.5vw; width:54% !important">
                            {{selectedWorkorder.ProgramName}}
                        </span>
                        <a *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad" href=""
                            (click)="showWorkorderHistory(selectedWorkorder.WorkorderId);">
                            <label style="margin-right:1vw;  
                        text-align: center;cursor: pointer;
                        font-size: 1.2vw;margin-top:0.5vw;float:right">Workorder :
                                {{selectedWorkorder.WorkorderName}}</label></a>
                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%;margin-top:1vw; margin-left:1vw; height:7vw; float:left">
                            <mat-card-header class="workorderHeaders">Customer Details</mat-card-header>
                            <mat-card-content>
                                <label class="labelStyle"> {{selectedWorkorder.CustomerName | titlecase}} </label>
                                <label class="labelStyle"> {{selectedWorkorder.CustomerStreet | titlecase}} </label>
                                <label class="labelStyle"> {{selectedWorkorder.CustomerCity | titlecase}},
                                    {{selectedWorkorder.CustomerState | uppercase}} {{selectedWorkorder.CustomerZip}}
                                </label>
                            </mat-card-content>
                        </mat-card>
                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%; height:7vw; margin-right:1vw; float:right;margin-top:1vw;">
                            <mat-card-header class="workorderHeaders">Payee Details</mat-card-header>
                            <mat-card-content>
                                <div>
                                    <label class="labelStyle"> {{selectedWorkorder.PayeeName | titlecase}} </label>
                                    <label class="labelStyle"> {{selectedWorkorder.PayeeEmail}}</label>
                                    <label class="labelStyle"> {{selectedWorkorder.PayeeAddress | titlecase}} </label>
                                    <label class="labelStyle"> {{selectedWorkorder.PayeeCity | titlecase}},
                                        {{selectedWorkorder.PayeeState | uppercase}} {{selectedWorkorder.PayeeZip}}
                                    </label>
                                </div>

                            </mat-card-content>
                        </mat-card>
                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%;  height:12vw;margin-left:1vw;  float:left;margin-top:0.5vw;">
                            <mat-card-header class="workorderHeaders">Rebate Details</mat-card-header>
                            <mat-card-content>
                                <label class="labelStyle"> Amount Paid : {{selectedWorkorder.AmountPaid}} </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> Check # :
                                    {{selectedWorkorder.CheckNumber}}
                                </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> Date Paid :
                                    {{selectedWorkorder.DatePaid | date : 'M/dd/yy'}} </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> Emailed or Mailed :
                                    {{selectedWorkorder.MailorEmail}}
                                </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> Payment Status
                                    :{{selectedWorkorder.PaymentStatus}} </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> WorkorderStatus Date :
                                    {{selectedWorkorder.WorkorderStatusDate | date : 'M/dd/yy'}} </label>
                                <label class="labelStyle" style="margin-top:0.5vw"> Workorder Application Source :
                                    {{selectedWorkorder.WorkorderApplicationSource?
                                    selectedWorkorder.WorkorderApplicationSource:' '}} </label>
                            </mat-card-content>
                        </mat-card>

                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%;  height:12vw; margin-right:1vw; float:right;margin-top:0.5vw">
                            <mat-card-header class="workorderHeaders">
                                Contractor Details
                            </mat-card-header>
                            <mat-card-content style="margin-top:0.5vw">
                                <label class="labelStyle" style="text-align: left;"> Service Provider Name :
                                    {{selectedWorkorder.ServiceProviderName}}</label>
                                <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Contractor Phone :
                                    {{selectedWorkorder.ContractorPhone}}</label>
                                <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Contractor Email :
                                    {{selectedWorkorder.ContractorEmail}}</label>
                                <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Company Contact :
                                    {{selectedWorkorder.CompanyContact}} </label>
                            </mat-card-content>
                        </mat-card>
                        <mat-card [hidden]="!(!showWorkorderLoad && showWorkorder && !showInteractionLoad)" style="vertical-align: middle;
                    margin-top: 26.5vw !important;
                    margin: 0 auto;
                    width: 50%;
                    height: 11vw;">
                            <mat-card-header class="workorderHeaders">Attachments</mat-card-header>
                            <mat-card-content [hidden]="!showWorkorder">
                                <div *ngIf="showAttachMessage" style="text-align: center;margin:1vw">
                                    <label>{{attachmentMessage}}</label>
                                </div>
                                <table *ngIf="!showAttachMessage"
                                    style="width: 100% !important; margin-top: 0.5vw !important" mat-table
                                    [dataSource]="dataSource3" class="mat-elevation-z8">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                            *matHeaderCellDef style="font-size:0.8vw">Name</th>
                                        <td style="font-size:0.8vw" mat-cell *matCellDef="let attachment">
                                            {{attachment.FileName}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="date">
                                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                            *matHeaderCellDef style="font-size:0.8vw">Date</th>
                                        <td style="font-size:0.8vw" mat-cell *matCellDef="let attachment">
                                            {{attachment.DateUploaded | date:'M/d/yyyy'}}</td>
                                    </ng-container>
                                    <tr mat-header-row [class]="workorderService.getCustomCSSForOfficeId(false)"
                                        *matHeaderRowDef="displayedColumns4"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns4;"
                                        (click)="handleAttachmentClick(row)" class="curr-workorder"></tr>
                                </table>
                                <mat-paginator #attachpaginator [pageSize]="3" showFirstLastButtons></mat-paginator>
                            </mat-card-content>
                        </mat-card>
                        <!-- <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad" style="vertical-align: middle;
                        margin-top: 23.5vw !important;
                        margin: 0 auto;
                        width: 50%;
                        height: 7vw;">
                        <mat-card-header class="workorderHeaders">
                            Contractor Details
                        </mat-card-header>
                        <mat-card-content style="margin-top:0.5vw">
                            <label class="labelStyle" style="text-align: left;"> Service Provider Name :
                                {{selectedWorkorder.ServiceProviderName}}</label>
                            <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Contractor Phone :
                                {{selectedWorkorder.ContractorPhone}}</label>
                            <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Contractor Email :
                                {{selectedWorkorder.ContractorEmail}}</label>
                            <label class="labelStyle" style="margin-top:0.5vw;text-align: left;"> Company Contact :
                                {{selectedWorkorder.CompanyContact}} </label>
                        </mat-card-content>
                    </mat-card> -->
                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%;  height:11vw; margin-right:1vw; float:right;margin-top:0.5vw">
                            <mat-card-header class="workorderHeaders">
                                Workorder Notes
                            </mat-card-header>
                            <mat-card-content style="margin-top:0.5vw">
                                <label *ngIf="selectedWorkorder.InstalledWONotes"
                                    style="font-size: 0.8vw">{{selectedWorkorder.InstalledWONotes}}</label>
                                <label *ngIf="!selectedWorkorder.InstalledWONotes" style="font-size: 0.8vw">No Workorder
                                    Notes</label>
                            </mat-card-content>
                        </mat-card>

                        <mat-card
                            *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad && ['Deactivated', 'Canceled'].includes(selectedWorkorder.WorkorderStatus)"
                            style="width:40%;  height:11vw; margin-right:1vw; float:right;margin-top:0.5vw">
                            <mat-card-header class="workorderHeaders" style="color:red;font-size: 1vw">
                                Deactivate/Cancel Reason
                            </mat-card-header>
                            <mat-card-content style="margin-top:0.5vw">
                                <label style="font-size: 0.8vw"
                                    *ngIf="selectedWorkorder.DeactivationReasons">{{selectedWorkorder.DeactivationReasons}}</label>
                                <label style="font-size: 0.8vw" *ngIf="!selectedWorkorder.DeactivationReasons"></label>
                            </mat-card-content>
                        </mat-card>
                        <mat-card *ngIf="showWorkorder && !showWorkorderLoad && !showInteractionLoad"
                            style="width:40%;  height:11vw; margin-right:1vw; float:right;margin-top:0.5vw">
                            <mat-card-header class="workorderHeaders" style="color:red;font-size: 1vw">
                                Workorder Exceptions
                            </mat-card-header>
                            <mat-card-content style="margin-top:0.5vw">
                                <label style="font-size: 0.8vw"
                                    *ngIf="selectedWorkorder.WorkorderExceptions">{{selectedWorkorder.WorkorderExceptions}}</label>
                                <label style="font-size: 0.8vw" *ngIf="!selectedWorkorder.WorkorderExceptions">No
                                    Workorder
                                    Exceptions</label>
                            </mat-card-content>
                        </mat-card>
                    </mat-tab>

                    <mat-tab label="Measures" #measuresTab [disabled]='!showWorkorder'>

                        <!--  <mat-spinner *ngIf="measuresSearching && measures.MeasuresArray.length === 0" [diameter]="70"
                        color="primary" style="margin: 0 auto; width:50%; height: 100%; margin-top:0.5vw">
                    </mat-spinner> -->


                        <div *ngIf="!measuresSearching && measures.MeasuresArray.length === 0"
                            style="color: red; font-size: 1vw;">
                            No measures for the selected
                            workorder</div>
                        <div [hidden]="!measuresSearching  &&  !(measures.MeasuresArray.length > 0)">
                            <mat-paginator style="float: right !important" #MeasurePaginator
                                [length]="totalRows$ | async" [pageIndex]="0" [pageSize]="10"
                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

                            <button matTooltip="Collapse All" matTooltip="Unfold less" mat-button (click)="closeAll()"
                                style="margin-top: 0.5vw">
                                <mat-icon style="color: black;" aria-hidden="false" aria-label="collapse">unfold_less
                                </mat-icon>
                            </button>
                            <br>
                            <mat-accordion #accordion="matAccordion" displayMode="flat" [multi]="true" class="mat-table"
                                style=" table-layout: fixed;width:100% !important;">

                                <br>
                                <mat-expansion-panel *ngFor="let measure of displayedRows$ | async"
                                    style="margin: 0.2vw">
                                    <mat-expansion-panel-header class="mat-row">
                                        <span style="width:30%" class="mat-cell">{{measure.Name}}</span>
                                        <span style="width:25%" class="mat-cell">{{measure.Category}}</span>
                                        <span style="width:15%" class="mat-cell">{{measure.Quantity}}</span>
                                        <span style="width:24%" class="mat-cell">{{measure.Status}}</span>
                                        <span style="width:15%" class="mat-cell">{{measure.Cost}}</span>
                                    </mat-expansion-panel-header>
                                    <tr *ngIf="measure.Notes">Notes : {{measure.Notes}}</tr>
                                    <div *ngIf=" measure.MeasureAttributes.length === 0"
                                        style="color: red; font-size: 1vw;">No
                                        attributes for the current measure</div>
                                    <table *ngIf="measure.MeasureAttributes.length > 0" class="mat-elevation-z8"
                                        style="table-layout: fixed;width:50%; margin:0 auto">
                                        <th [class]="workorderService.getCustomCSSForOfficeId(false)"
                                            class="backgroundClass"
                                            style="text-align: left; font-size: 0.7vw ; color:whitesmoke;">
                                            Attribute Name
                                        </th>
                                        <th [class]="workorderService.getCustomCSSForOfficeId(false)"
                                            class="backgroundClass"
                                            style="text-align: left; font-size: 0.7vw;color:whitesmoke;">
                                            Attribute Value
                                        </th>
                                        <tbody>

                                            <tr *ngFor="let attr of measure.MeasureAttributes" class="alternateColors">
                                                <td style="font-size: 0.7vw">{{attr.Name}}</td>
                                                <td style="font-size: 0.7vw">{{attr.Value}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>


                    </mat-tab>

                    <mat-tab label="Exceptions" #exceptionsTab [disabled]='!showWorkorder'>
                        <!-- 
                    <mat-spinner *ngIf="exceptionSearching" [diameter]="70" color="primary"
                        style="margin: 0 auto; width:50%; height: 100%; margin-top:0.5vw">
                    </mat-spinner>
 -->

                        <div *ngIf="!exceptionSearching && measures.MeasuresArray.length === 0"
                            style="color: red; font-size: 1vw;">
                            No exceptions for the selected workorder
                        </div>
                        <div [hidden]="!exceptionSearching  &&  !(measures.MeasuresArray.length > 0)">
                            <!--
                        <mat-paginator style="float: right !important" #MeasurePaginator [length]="totalRows$ | async"
                            [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

                        <button matTooltip="Collapse All" mat-button (click)="closeAll()" style="margin-top: 0.5vw">
                            <mat-icon style="color: black;" aria-hidden="false" aria-label="collapse">unfold_less
                            </mat-icon>
                        </button>
                        <br>
                        <mat-accordion #accordion="matAccordion" displayMode="flat" [multi]="true" class="mat-table"
                            style=" table-layout: fixed;width:100% !important;">

                            <br>
                            <mat-expansion-panel *ngFor="let measure of displayedRows$ | async" style="margin: 0.2vw">
                                <mat-expansion-panel-header class="mat-row">
                                    <span style="width:30%" class="mat-cell">{{measure.Name}}</span>
                                    <span style="width:25%" class="mat-cell">{{measure.Category}}</span>
                                    <span style="width:15%" class="mat-cell">{{measure.Quantity}}</span>
                                    <span style="width:24%" class="mat-cell">{{measure.Status}}</span>
                                    <span style="width:15%" class="mat-cell">{{measure.Cost}}</span>
                                </mat-expansion-panel-header>
                                <tr *ngIf="measure.Notes">Notes : {{measure.Notes}}</tr>
                                <div *ngIf=" measure.MeasureAttributes.length === 0"
                                    style="color: red; font-size: 1vw;">No
                                    attributes for the current measure</div>
                                <table *ngIf="measure.MeasureAttributes.length > 0" class="mat-elevation-z8"
                                    style="table-layout: fixed;width:50%; margin:0 auto">
                                    <th class="backgroundClass"
                                        style="text-align: left; font-size: 0.7vw ; color:whitesmoke;">
                                        Attribute Name
                                    </th>
                                    <th class="backgroundClass"
                                        style="text-align: left; font-size: 0.7vw;color:whitesmoke;">
                                        Attribute Value
                                    </th>
                                    <tbody>

                                        <tr *ngFor="let attr of measure.MeasureAttributes" class="alternateColors">
                                            <td style="font-size: 0.7vw">{{attr.Name}}</td>
                                            <td style="font-size: 0.7vw">{{attr.Value}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </mat-expansion-panel>

                        </mat-accordion>
                        -->
                        </div>


                    </mat-tab>
                    <mat-tab label="Add Interactions" #addInteractionsTab *ngIf="showAddInteractions">
                        <table style="font-size: 1vw;">
                            <tr>
                                <td>
                                    <span style="float: right;">{{ timer }}</span>
                                </td>
                            </tr>
                        </table>
                        <br>
                        <table style="font-size: 1vw;">
                            <tr>
                                <td style="text-align: center">
                                    <mat-form-field>
                                        <mat-label>Type</mat-label>
                                        <mat-select [(ngModel)]="selectedTypeCode"
                                            (selectionChange)="changeType($event)">
                                            <mat-option *ngFor="let typeobj of types" [value]="typeobj"
                                                style="font-size: 11px;">
                                                {{typeobj.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td style="text-align: center">
                                    <mat-form-field>
                                        <mat-label>Why</mat-label>
                                        <mat-select [(ngModel)]="selectedWhy">
                                            <mat-option *ngFor="let why of whys" [value]="why" style="font-size: 11px;">
                                                {{why.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td style="text-align: center">
                                    <mat-form-field>
                                        <mat-label>Marketing</mat-label>
                                        <mat-select [(ngModel)]="selectedMarketing">
                                            <mat-option *ngFor="let marketObj of marketing" [value]="marketObj"
                                                style="font-size: 11px;">
                                                {{marketObj.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <mat-form-field style="width: 100%;">
                                        <textarea matInput rows="3" placeholder="Notes" value=""
                                            [(ngModel)]="notesInput"></textarea>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <mat-checkbox #completeCheckbox (change)="onCompleteClick($event)">Complete
                                    </mat-checkbox>
                                </td>
                                <td style="width:100% !important; padding-right:4vw">
                                    <mat-form-field style="width:18vw">
                                        <mat-label>Reason</mat-label>
                                        <mat-select [disabled]="checkIfComplete" [(ngModel)]="selectedReason">
                                            <mat-option *ngFor="let reason of reasons" [value]="reason"
                                                style="font-size: 11px;">
                                                {{reason.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td>
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3" style="text-align: center">
                                    <button mat-button color="primary" style="font-weight: 600;"
                                        (click)="addInteraction();"
                                        [disabled]="checkGoodDropForm() || adding">Save</button>
                                    <button mat-button color="primary" style="font-weight: 600;"
                                        [mat-dialog-close]="true" (click)="closeInteractions()">Cancel</button>
                                </td>
                            </tr>
                            <tr>
                                <td>{{statusMessage}}</td>
                            </tr>
                        </table>
                    </mat-tab>
                </mat-tab-group>

            </mat-card-content>
        </mat-card>
        <mat-card style="float:left; clear: left; width: 35%; height:auto; margin-top:1vw;margin-bottom: 1vw"
            [hidden]="customerService.isBbcs()">
            <mat-card-header class="mat-header-color" style="align-items: center;font-size:0.9vw;color:whitesmoke ;
        padding-top:0.8vw;padding-bottom: 0.8vw">
                Work Orders
            </mat-card-header>

            <mat-card-content>
                <mat-spinner *ngIf="loadWorkorder" [diameter]="40"
                    style="margin:0 auto; text-align:center; margin-top:5vw">
                </mat-spinner>

                <table *ngIf="workorderDisplay && !loadWorkorder"
                    style="width: 100% !important; margin-top: 1.2vw !important" mat-table [dataSource]="dataSource2"
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="Name">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)" *matHeaderCellDef
                            style="text-align: left;font-size: 0.8vw">Name</th>
                        <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                            {{workorder.Name}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="StatusDate">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)" *matHeaderCellDef
                            style="text-align: left;font-size: 0.8vw">Status Date</th>
                        <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                            {{workorder.StatusDate | date:'M/d/yyyy'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Status">
                        <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)" *matHeaderCellDef
                            style="text-align: left;font-size: 0.8vw">Status</th>
                        <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                            {{workorder.Status}}</td>
                    </ng-container>
                    <tr mat-header-row [class]="workorderService.getCustomCSSForOfficeId(false)"
                        *matHeaderRowDef="displayedColumns3"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns3;" (click)="handleWorkorderClick(row)"
                        class="curr-workorder"></tr>
                </table>
                <div *ngIf="!workorderDisplay && !loadWorkorder" style="
            vertical-align: middle;
            text-align: center;
            margin: 0 auto;
            margin-top: 10vw;">No workorders for the current user</div>
            </mat-card-content>
            <!-- <mat-paginator #wopaginator [pageSize]="5" showFirstLastButtons></mat-paginator> -->
        </mat-card>

        <mat-card style="float:left; clear: left; width: 35%; height: auto; margin-top:1vw;margin-bottom: 1vw"
            [hidden]="!customerService.isBbcs()">
            <mat-card-header [class]="workorderService.getCustomCSSForOfficeId(false)"
                style="align-items: center;font-size:0.9vw;color:whitesmoke;">
                Enrollments
                <button mat-button [matMenuTriggerFor]="progmenu" matTooltip="Add"
                    style="background: transparent;margin-left:18vw !important">
                    <mat-icon>add</mat-icon>
                </button>

                <mat-menu #progmenu="matMenu">
                    <button mat-menu-item *ngFor="let enaction of enrollmentActions;"
                        (click)="handleEnrollment(enaction)">
                        {{enaction.Value}}
                    </button>
                </mat-menu>
            </mat-card-header>

            <mat-card-content>
                <mat-spinner *ngIf="loadWorkorder" [diameter]="40"
                    style="margin:0 auto; text-align:center; margin-top:5vw">
                </mat-spinner>

                <div *ngIf="enrollments.EnrollmentArray.length < 1 && !loadWorkorder" style="
            vertical-align: middle;
            text-align: center;
            margin: 0 auto;
            margin-top: 2vw;">No enrollments for the current user</div>

                <mat-accordion class="mat-table" style="table-layout: fixed;width:100% !important;">
                    <br>
                    <mat-expansion-panel class="enrollmentPanel" *ngFor="let wo of displayedEnrollmentRows$ | async">
                        <mat-expansion-panel-header class="mat-row">
                            <mat-panel-title class="enroll-title">
                                <span class="mat-cell"
                                    style="font-size:0.8vw;text-align: left">{{wo.ProgramDesc}}</span>
                                <span class="mat-cell" style="font-size:0.8vw;text-align: left"> {{wo.StatusDesc}},
                                    Started
                                    {{wo.StartDate | date:'M/d/yyyy'}}</span>
                            </mat-panel-title>

                            <button mat-button [matMenuTriggerFor]="menu" matTooltip="Menu">
                                <mat-icon style="text-align: left">add</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="addAtWorkorderLevel(wo.EnrollmentId)">Add
                                    Workorder</button>
                                <!--  <button mat-menu-item [matMenuTriggerFor]="setup">SetUp</button> -->
                            </mat-menu>
                        </mat-expansion-panel-header>
                        <table *ngIf="wo.Workorders !== undefined && wo.Workorders.length > 0"
                            style="width: 30vw !important; margin-top: 1.2vw !important;" mat-table
                            [dataSource]="wo.Workorders" class="mat-elevation-z8">
                            <ng-container matColumnDef="Name">
                                <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                    *matHeaderCellDef style="text-align: left;font-size: 0.8vw">Name</th>
                                <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                                    {{workorder.Workorder}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Description">
                                <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                    *matHeaderCellDef style="text-align: left;font-size: 0.8vw">Description</th>
                                <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                                    {{workorder.ProgramdetailDesc}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="StatusDate">
                                <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                    *matHeaderCellDef style="text-align: left;font-size: 0.8vw">Status Date
                                </th>
                                <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                                    {{workorder.StatusDate | date:'M/d/yyyy'}}</td>
                            </ng-container>
                            <ng-container matColumnDef="Status">
                                <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                    *matHeaderCellDef style="text-align: left;font-size: 0.8vw">Status</th>
                                <td style="font-size:0.8vw;text-align: left" mat-cell *matCellDef="let workorder">
                                    {{workorder.StatusDesc}}&nbsp;<span
                                        *ngIf="workorder.Pendhold !== ' '">({{workorder.Pendhold}})</span>
                                </td>
                            </ng-container>

                            <!-- ExpandCollapse Icon Column -->
                            <ng-container matColumnDef="ExpandCollapse">
                                <th mat-header-cell [class]="workorderService.getCustomCSSForOfficeId(false)"
                                    *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button color="primary" matTooltip="Expand">
                                        <mat-icon id="expand_more"  #expand_more *ngIf="!element.close"
                                             >expand_more</mat-icon>
                                        <mat-icon id="expand_less"  #expand_less
                                            *ngIf="element.close">expand_less</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns5"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns5;"
                                (dblclick)="handleEnrollmentWorkorderClick(row, wo.EnrollmentId)" [cdkDetailRow]="row"
                                [cdkDetailRowTpl]="tpl" (toggleChange)="onToggleChange($event,row)"
                                class="curr-workorder element-row">
                            </tr>
                        </table>
                        <!--  <mat-paginator #wopaginator [pageSize]="2" showFirstLastButtons [length]="wo.Workorders.length">
                    </mat-paginator> -->
                        <div *ngIf="wo.Workorders === undefined || wo.Workorders.length < 1" style="
                vertical-align: middle;
                text-align: center;
                margin: 0 auto;
                margin-top: 2vw;">No workorders for the current user</div>


                    </mat-expansion-panel>


                </mat-accordion>
            </mat-card-content>
            <mat-paginator style="float: right !important" #EnrollPaginator [length]="totalEnrollmentRows$ | async"
                [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[50, 100]">
            </mat-paginator>
        </mat-card>
    </div>

    <ng-template #tpl let-element>
        <!-- <div class="mat-row-assignments" [@detailExpand] > -->
        <!-- <ul *ngFor="let assign of element.Assignments"> -->
        <tr [@detailExpand] *ngFor="let assign of element.Assignments">
            <td colspan="5" style="font-size: 0.75vw;">
                <div class="assign-dt">
                    <span class="name-span">{{assign.Status}}</span>
                    <span>{{assign.Assignee}}</span>
                    <span>Start Date: {{assign.Start}}</span>
                </div>
            </td>
        </tr>
        <!-- </ul> -->
        <!-- </div> -->
    </ng-template>
</ng-template>